(function () {
  const pageData = document.getElementById('gtm-page-data')?.dataset ?? {};
  const currency = pageData.currency || 'INR';

  function trackEvent(eventName, params) {
    // Google Tag Manager — conversion tags fire off these events in GTM
    if (window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        ...params,
      });
    }
  }

  function getCartTotal() {
    const totalText = document.querySelector('.checkout-total-price')?.textContent ?? '';
    const parsedTotal = parseFloat(totalText.replace(/[^0-9.]/g, ''));
    return Number.isNaN(parsedTotal) ? Number(pageData.cartTotal ?? 0) : parsedTotal;
  }

  // --- add_to_cart -----------------------------------------------------------
  document.addEventListener('click', function (e) {
    const atcBtn = e.target.closest('.cartx-add-to-cart');
    if (!atcBtn || atcBtn.classList.contains('cartx-sold-out')) return;

    const buttonWrap = atcBtn.closest('.cartx-product-button-wrap');
    const productTitle = buttonWrap?.dataset.productTitle || 'Unknown product';
    const price = Number(buttonWrap?.dataset.price ?? 0) / 100;

    trackEvent('add_to_cart', {
      currency: currency,
      value: price,
      product_title: productTitle,
    });
  });

  // --- begin_checkout --------------------------------------------------------
  document.addEventListener('click', function (e) {
    const checkoutBtn = e.target.closest('.cartx-checkout-button');
    if (!checkoutBtn) return;

    trackEvent('begin_checkout', {
      currency: currency,
      value: getCartTotal(),
    });
  });

  // --- view_cart ---------------------------------------------------------
  document.addEventListener('click', function (e) {
    const cartIconBtn = e.target.closest('.cartx-icon');
    if (!cartIconBtn) return;

    trackEvent('view_cart', {
      currency: currency,
      value: getCartTotal(),
    });
  });
})();
